import cx from 'classnames';
import { ImageBox } from 'Styles';
import { UserStoryCard, DownloadButton } from 'Elements';
import styles from 'partials/image-clip.module.scss';

export const ImageClip = ({ image, className, onClick }) => {
	const imageClass = cx(styles.box, className);

	return (
		<div className={imageClass}>
			<ImageBox className={styles.imageBox}>
				{/* eslint-disable-next-line */}
				<img
					src={image.src}
					alt={image.title}
					className={styles.image}
					onClick={onClick}
				/>
			</ImageBox>
			<div className={styles.content}>
				{/* eslint-disable-next-line */}
				<h3 className={styles.title} onClick={onClick}>
					<span className={styles.titleLink}>{image.title}</span>
				</h3>
				<div className={styles.meta}>
					<UserStoryCard user={image.user} />
					<DownloadButton url={image.src} size={image.size} />
				</div>
			</div>
		</div>
	);
};
